var map = {
	"./audit.json": 736,
	"./calculations.json": 737,
	"./calendar.json": 322,
	"./cdr.json": 738,
	"./chancellery.json": 739,
	"./clients.json": 740,
	"./company-settings.json": 741,
	"./controlCard.json": 742,
	"./csv.json": 743,
	"./datatable.json": 744,
	"./dnaMarkers.json": 745,
	"./dnaTests.json": 746,
	"./eqTypes.json": 747,
	"./equipments.json": 748,
	"./experiments.json": 749,
	"./formulations.json": 750,
	"./invoice.json": 751,
	"./laboratories.json": 752,
	"./locations.json": 753,
	"./lookup.json": 754,
	"./maintTypes.json": 755,
	"./materialTypes.json": 756,
	"./materials.json": 757,
	"./metadata.json": 758,
	"./notifications.json": 759,
	"./orders.json": 760,
	"./productTrends.json": 761,
	"./projects.json": 762,
	"./queryTemplate.json": 763,
	"./reports.json": 764,
	"./samples.json": 765,
	"./signin.json": 766,
	"./signup.json": 767,
	"./slowQueryLogger.json": 768,
	"./specifications.json": 769,
	"./suppliers.json": 770,
	"./tasks.json": 771,
	"./testPlans.json": 772,
	"./testReports.json": 773,
	"./tests.json": 774,
	"./transactions.json": 775,
	"./translation.json": 776,
	"./uom.json": 777,
	"./validation.json": 778
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 735;